import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as isEqual from 'react-fast-compare';
import ListField from './listfield';
import { resolveCondition } from '../../condition';
import { asBool } from '../input/utils';
import { listPathId } from '.';
import { firstValid } from '../../utils';

const ListData = ({ struct, idx, path, elm, min, childCount, notremovable, flexgrow = false, removeItem, dispatch, itemPreview, parent, accordion = false, noheader = false, globalpath = false, ...props }) => {
	const id = `itemlist${listPathId(props.form_path)}${listPathId(path)}${idx}`
	const parentId = accordion ? `#input${listPathId(path)}` : null
	// const id = `itemlist${(props.form_path || "").replace(/([._-]+)/g, '')}${(path || "").replace(/([._-]+)/g, '')}${idx}`
	const [sectionMode, setSectionMode] = useState({});
	const removable = asBool(notremovable) ? false : (isNaN(min) ? true : childCount > Number(min))

	const itemClass = `list-group-item ${flexgrow ? 'flex-grow-1' : ''} py-1 pl-2 ${removable ? "pr-1" : "pr-2"} bg-transparent ${path ? "border-bottom rounded-bottom" : "border-0"}`
	const dragClass = `drag-handle-${(path || "").replace(/([._-]+)/g, '')} p-2`
	const shouldshow = !path || noheader || isEqual(elm, {}) ? "show" : "";
	const [show] = useState(shouldshow)

	if (!elm) return null;
	let hiddenSection = false;
	let disabledSection = {};
	let isreadmode = false;

	//style={({ backgroundColor:"rgba(226, 233, 233, 0.8)" })}
	return (
		<li key={idx} className={itemClass}>
			<div className="card bg-transparent m-0" style={({ boxShadow: "none" })} >
				{
					path && !noheader &&
					<div className="card-header p-0 pr-3 border-0" >
						{
							childCount > 1 &&
							<span className={dragClass} style={{ cursor: "move" }} >
								<FontAwesomeIcon icon={["fas", "grip-lines"]} />
							</span>
						}
						<a href={`#${id}`} className="text-dark " data-toggle="collapse" >{`${idx + 1}: ${itemPreview(elm)}`}</a>
						<div className="card-tools">
							{removable && <button type="button" className="btn btn-tool text-red" onClick={() => removeItem(idx)} ><FontAwesomeIcon icon={["far", "trash-alt"]} /></button>}
						</div>
					</div>
				}
				<div id={id} className={`collapse ${show}`} data-parent={parentId} >
					<div className="card-body p-1">
						<div className="form-row">
							{
								struct.map((field, fieldIndex) => {

									/**
									 * options: 
									 * 	1. type:list + globalpath:true + path:some_path   		-> elements in list will be located in some_path.1, some_path.2, etc. (inside form_data)
									 * 	2. type:list + globalpath:true + path:%EMPTY_STRING%  -> elements in list will be located at parent path, as if the list does not exists.
									 * 	3. type:other + globalpath:true + path:some_path  		-> this particular field data will be located in some_path (inside form_data)
									 * 	4. type:other + globalpath:true + path:%EMPTY_STRING% -> weird case, this particular field data will be it's parent object data. like a json field editing it's parent content. maybe buttons defined as a list?
									 */
									const newpath = field.globalpath || !path ? (firstValid(field.path, field.name, '')) : `${firstValid(path, '')}.${idx.toString()}.${firstValid(field.path, field.name, '')}`

									const conditionResult = resolveCondition(field.condition, { global: props.pageData, local: { parent, ...elm } })
									const ishidden = (conditionResult === "hide" || !conditionResult) ? true : false
									const isdisabled = conditionResult === "disable" ? { readonly: true } : {}

									const issection = field.type === "section"

									if (issection) { //save ishidden && isreadmode state for entire section.
										hiddenSection = ishidden
										disabledSection = isdisabled
										isreadmode = !!field.modes && field.modes !== 'edit' && (sectionMode[field.name] || (sectionMode[field.name] !== false && (field.initmode || 'read') === 'read'))
									}

									const toggleReadMode = issection && field.modes === 'both' ? (mode) => setSectionMode({ ...sectionMode, [field.name]: mode }) : null

									if (ishidden || hiddenSection || (isreadmode && !issection)) return null;
									else return <ListField key={newpath} rowIndex={idx} path={newpath} fieldIndex={fieldIndex} field={({ ...field, ...isdisabled, ...disabledSection })} dispatch={dispatch} toggleReadMode={toggleReadMode} isreadmode={isreadmode} fieldData={({ parent, ...elm })} {...props} />
								})
							}
						</div>
					</div>
				</div>

			</div>
		</li>
	)
}

export default ListData;

